/**
 * Session cache for "My Chats" sidebar list (ChatBar remounts when leaving Live route).
 * Cleared when the user refreshes the chat list from LiveChat.
 */
const emptyCache = () => ({
  businessId: null,
  /** null = never loaded; [] = loaded empty */
  data: null,
  hasFetched: false,
  assignedCount: 0,
  hasMore: true,
});

let cache = emptyCache();

export function getActiveChatListWarmCache() {
  return cache;
}

export function setActiveChatListWarmCache(next) {
  cache = { ...emptyCache(), ...next };
}

export function clearActiveChatListWarmCache() {
  cache = emptyCache();
}
